import React from 'react';
import { OverlayTrigger, FormGroup } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { isEmpty } from 'lodash';

export default function TextCard({
  item,
  index,
  handleChanged,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  onChange,
  isUniqueId,
}) {
  return (
    <div className="d-flex flex-wrap mt-2 align-items-center justify-content-center">
      <div key={index} className="freetext-container mb-2 flex-fill">
        <div className="input-container">
          <div className="input-group form-floating-label fixed-label">
            <input
              key={index}
              name="freeLabel"
              autoFocus={!item?._id}
              value={item?.keyName ? item?.keyName : ''}
              placeholder="Enter Free Text Title"
              type="text"
              onChange={(e) => handleChanged(e, index)}
              className="form-control"
              maxLength="50"
            />
            <label className="asterisk-req">
              Free Text Label<span>*</span>
            </label>
          </div>
          {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && <label className="text-danger m-0 p-1">Text is required.</label>}
        </div>
        <div className="input-action d-flex">
          {item?._id !== '' && (
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
              <button type="button" className="btn btn-outline mr-0" onClick={() => activeInactiveClicked(item?._id)} id={item?._id}>
                <span className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
              </button>
            </OverlayTrigger>
          )}
          <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
            <button
              className="btn btn-outline mr-0"
              type="button"
              // title="Delete"
              aria-label="Delete"
              onClick={() => {
                handleDelete(item?._id ? item?._id : index);
              }}
            >
              <span className="icon-delete f-20" />
            </button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={
              <Popover className="custom-popover size-md">
                <Popover.Title as="p">Character Count</Popover.Title>
                <Popover.Content>
                  <FormGroup className="d-flex align-items-center mb-2">
                    <input
                      type="number"
                      min="0"
                      max="30"
                      className="form-control text-bordered w-80px mr-2"
                      value={item?.textFieldConfig?.charLimit}
                      onChange={(e) => onChange(e.target.value, index, 'textFieldConfig.charLimit')}
                    />
                    <span>
                      Character Limit <small>(Maximum 30 character)</small>
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="category3CheckBox"
                        id={`editableCheck${index}`}
                        onChange={(e) => onChange(e.target.checked, index, 'textFieldConfig.isEditable')}
                        checked={item?.textFieldConfig?.isEditable}
                      />
                      <label htmlFor={`editableCheck${index}`} className="custom-control-label">
                        <span>Editable field</span>
                      </label>
                    </div>
                  </FormGroup>
                </Popover.Content>
              </Popover>
            }
            trigger="click"
            rootClose
          >
            {/* <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipEdit}> */}
            <button type="button" title="Edit" aria-label="Edit" className="btn btn-outline mr-0">
              <span className="icon-edit f-20" />
            </button>
          </OverlayTrigger>
          {/* </OverlayTrigger> */}
        </div>
      </div>
      {!isEmpty(isUniqueId) && isUniqueId?.includes(index) && <label className="text-danger m-0 p-1">This entery already Exist</label>}
      {/* <div className="product-type-container type-text">
        <CommonMultiSelect
          label="Product Type"
          required
          onChange={(e) => onDropSelectionChange(e, index)}
          selectedValue={item?.productType || []}
          optionList={item?._id ? pcTypeList : pcTypeList?.filter((e) => e?.isActive) || []}
          selectLabel="name"
          selectValue="_id"
          disable={item?._id}
        />
        {item?.isEmpty && item?.productType?.length === 0 && <label className="text-danger m-0 p-1">Product type is required.</label>}
      </div> */}
    </div>
  );
}
